import React, { useRef, useState } from "react";
// import { Link } from "react-router-dom";
import cogoToast from "cogo-toast";
import CustomButton from "../../../../components/CustomButton";
import BackButton from "../../../../components/BackButton";
import { uploadFile } from "../../../../utils/helpers";
import { array, func, object } from "prop-types";
import CustomInput from "../../../../components/CustomInput";

const AddDocuments = ({ addDocLink, job, addDocLinkObject, linksObject, setLinksObject }) => {
  const [isUploading, setIsUploading] = useState(false);
  const [link, setLink] = useState("");
  const uploadInputRef = useRef(null);

  const handleChangeUpload = ({ target: { files } }) => {
    if (files && files[0]) {
      setIsUploading(true);

      Promise.resolve(
        uploadFile(
          files[0],
          "https://api.cloudinary.com/v1_1/workbrook-hash/raw/upload"
        )
      )
        .then(({ data, success }) => {
          if (success) {
            addDocLink(data);
            addDocLinkObject({ link: data, name: files[0].name });
            setLinksObject([...linksObject, { link: data, name: files[0].name }]);
          } else {
            cogoToast.error("Unsuccessful document upload", {
              hideAfter: 4,
              position: "top-center",
            });
          }
        })
        .finally(() => {
          setIsUploading(false);
        });
    }
  };

  const handleRefClick = () => {
    uploadInputRef.current.click();
  };

  const addLink = () => {
    if (!link.trim()) {
      return cogoToast.error("Field cannot be empty");
    }

    if (
      !link.includes("http://") &&
      !link.includes("https://") &&
      !link.includes("www.")
    ) {
      return cogoToast.error("Invalid url");
    }
    addDocLink(link);
    addDocLinkObject({ link, name: null });
    setLink("");
  };

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-medium mb-4">Link</h2>
        <div className="flex items-center gap-4">
          <input
            type="text"
            value={link}
            onChange={(e) => setLink(e.target.value)}
            placeholder="http://www.example.com"
            className="flex-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={addLink}
            className="px-6 py-2 text-blue-600 bg-white border border-blue-600 rounded-md hover:bg-blue-50 transition-colors"
          >
            Add Link
          </button>
        </div>
      </div>

      <div>
        <input
          ref={uploadInputRef}
          type="file"
          onChange={handleChangeUpload}
          className="hidden"
        />
        
        <div 
          onClick={handleRefClick}
          className="mt-4 border border-gray-200 rounded-lg p-4 text-center cursor-pointer hover:bg-gray-50 transition-colors"
        >
          <p className="text-blue-600 mb-1">Click to Select Document</p>
          <p className="text-sm text-gray-500">No document added</p>
        </div>
      </div>

      {linksObject.length > 0 && (
        <div className="space-y-2">
          {linksObject.map((fileLink, index) => (
            <div key={index} className="flex items-center gap-2">
              <a
                href={fileLink.link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 p-2 bg-gray-50 rounded-md hover:bg-gray-100 transition-colors"
              >
                {fileLink.name || fileLink.link}
              </a>
              <button
                onClick={() => {
                  const newLinks = [...linksObject];
                  newLinks.splice(index, 1);
                  setLinksObject(newLinks);
                }}
                className="p-1 text-red-600 hover:bg-red-50 rounded-full transition-colors"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

AddDocuments.propTypes = {
  addDocLink: func.isRequired,
  addDocLinkObject: func.isRequired,
  job: object.isRequired,
  linksObject: array.isRequired,
  setLinksObject: func.isRequired,
};

export default AddDocuments;
